import { MakeCall } from './createMakeCall';

const setPayoutMethodAsDefault =
  (makeCall: MakeCall) => (methodId: number | string) =>
    makeCall<undefined>('PUT', `/api/v2/user/me/payout-methods/set-default`, {
      data: { defaultMethodId: methodId },
    });
export { setPayoutMethodAsDefault };
